<h1 class="text-dark text-xl" mat-dialog-title>Modifica associazione veicolo</h1>
<div class="w-full" mat-dialog-content>
  <app-form-modify-association-insurance
    [data]="data.association"
    [dialogRef]="dialogRef"
  ></app-form-modify-association-insurance>
</div>
